@if (resolvedProduct(); as product) {
  @let isNotAvailable = !(product | sdProductIsAvailable);

  <div class="add-to-cart">
    @if (isNotAvailable && (!transitInstance || !transitSwitchState())) {
      <sd-watch-later />
    } @else if (transitInstance() && transitSwitchState()) {
      <sd-transit-order [product]="product" />
    } @else {
      <sd-product-button (click)="onAddToCart()" [product]="product" />
    }
  </div>
} @else {
  <div class="add-to-cart sd-group-skeleton-gradient-wave">
    <div class="sd-skeleton"></div>
  </div>
}
